import { Colors } from '../../themes/colors';
import '../../themes/global.scss';
import '../../themes/mapactiveoffer.scss';

import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createErrorObjectSelector, createLoadingSelector } from '../../api/selectors';

import {
  CANCEL_JOB_ACTION,
  DECLINE_COUNTER_OFFER,
  FETCH_JOB_ACTION,
  UPDATE_JOB_ACTION,
  cancelJob,
  fetchJob,
  getAllSkillCategories,
} from '../../actions';
import BackButton from '../../commonComponents/BackButton';
import { extractSkills } from '../../commonComponents/CommonFunctions';
import CustomSpinner from '../../commonComponents/CustomSpinner';
import browserHistory from '../../history';
import CloseIcon from '../../images/icons/CloseIcon';
import EditPencilIcon from '../../images/icons/EditPencil';
import TrashIcon from '../../images/icons/Trash';
import shareIcon from '../../images/share-icon.svg';
import InviteFavorites from '../InviteFavorites';
import AnimatedCloseCircle from '../shared/AnimatedCloseCircle';
import ConfirmPopup from '../shared/ConfirmPopup';

export default ({ history, match }) => {
  const dispatch = useDispatch();

  const loadingSelector = createLoadingSelector([
    FETCH_JOB_ACTION,
    UPDATE_JOB_ACTION,
    DECLINE_COUNTER_OFFER,
    CANCEL_JOB_ACTION,
  ]);
  const errorSelector = createErrorObjectSelector([
    FETCH_JOB_ACTION,
    UPDATE_JOB_ACTION,
    CANCEL_JOB_ACTION,
    DECLINE_COUNTER_OFFER,
  ]);

  const jobId = history.location.state ? history.location.state?.jobId : match.params?.jobId;

  const job = useSelector((state) => (jobId === state.job.job?.id ? state.job.job : null));

  const message = useSelector((state) => state.message.message);
  const isLoading = useSelector((state) => loadingSelector(state));
  const error = useSelector((state) => errorSelector(state));

  const allSkillCategories = useSelector(
    (state) => state.user.allSkillCategories,
  );

  const {
    allSpecialtySkills,
  } = extractSkills(allSkillCategories, job, null);

  const [showInviteFavoritesPopup, setShowInviteFavoritesPopup] = useState(false);
  const [cancelJobPopup, setCancelJobPopup] = useState(false);

  useEffect(() => {
    dispatch(fetchJob({ jobId }));

    if (!allSkillCategories || allSkillCategories?.length === 0) {
      dispatch(getAllSkillCategories());
    }
  }, []);

  useEffect(() => {
    if (job && (job.status === 'pending' || job.status === 'counter')) {
      history.replace(`/dashboard/candidates/${job.id}`);
    } else if (
      job
      && (job.status === 'filled' || job.status === 'pay-out' || job.status === 'complete')
    ) {
      history.replace(`/dashboard/job/${job.id}/details`);
    }
  }, [job]);

  if (isLoading || !job) {
    return (
      <div className="component_container">
        <CustomSpinner isLoading={isLoading} />
      </div>
    );
  }

  return (
    <div className="component_container">
      <div className="floating_container">
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div style={{
            width: '95%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 40,
          }}
          >
            {history.location.state?.isJobPost ? (
              <div
                onClick={() => browserHistory.push('/dashboard/home')}
                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
              >
                <CloseIcon color={Colors.secondary_500} />

                <p
                  style={{
                    fontFamily: 'Nunito',
                    fontWeight: 'bold',
                    fontSize: 20,
                    color: Colors.secondary_500,
                    marginLeft: 8,
                  }}
                >
                  Close
                </p>
              </div>
            ) : <BackButton />}

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div
                onClick={() => history.push(`/dashboard/temporaryJob/${jobId}/edit`)}
                className="buttons-container"
                style={{
                  marginRight: 40,
                }}
              >
                <div className="edit-button">
                  <EditPencilIcon className="icon" color="#FFFFFF" />
                </div>
                <p>Edit</p>
              </div>
              <div className="buttons-container">
                <div
                  className="trash-button"
                  onClick={() => setCancelJobPopup(true)}
                >
                  <TrashIcon className="icon" color="#FFFFFF" />
                </div>
                <p>Cancel</p>
              </div>
            </div>
          </div>
          <div style={{ width: '70%', paddingTop: 20 }}>
            <h1
              className="global_font f-dark"
              style={{
                fontSize: 32,
                fontWeight: 'bold',
                marginTop: 20,
                textAlign: 'center',
                width: '100%',
              }}
            >
              Shift Details
            </h1>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div
                style={{ width: 500, display: 'flex', flexDirection: 'column' }}
              >
                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    Office:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    {job.offer_owner.office_name}
                  </p>
                </div>

                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    Date:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    {job.local_date}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    Profession:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    {job.professionName}
                  </p>
                </div>

                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    {job.profession === 'DN' ? 'Shift Procedures:' : 'Preferred Specialty:'}
                  </p>
                  <p
                    className="global_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_500,
                      fontSize: 16,
                      textTransform: 'capitalize',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {job?.specialty?.split('_')?.[1] || 'General'}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    Hours:
                    <span style={{
                      fontSize: 12, color: Colors.white, background: Colors.neutral_300, borderRadius: 10, padding: '0 4px', marginLeft: 4, alignSelf: 'center', height: 15,
                    }}
                    >
                      {job.local_timezone}
                    </span>
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    {`${job.local_start_time} - ${job.local_end_time}`}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',

                    }}
                  >
                    Hourly Rate:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    $
                    {job.rate.toFixed(2)}
                  </p>
                </div>
                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    Break
                    {job.is_lunch_break_paid ? ' (Paid)' : ' (Unpaid)'}
                    :
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    {job.lunch_break_time}
                    {' '}
                    min
                  </p>
                </div>
                <div className="row_style">
                  <p
                    className="global_font bold_font"
                    style={{
                      margin: 0,
                      color: Colors.neutral_600,
                      fontSize: 18,
                      width: '40%',
                    }}
                  >
                    Auto-Confirm:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_500, fontSize: 16 }}
                  >
                    {job.autoFill ? 'On' : 'Off'}
                  </p>
                </div>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: 100,
                marginTop: 160,
              }}
            >
              <button
                type="button"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: Colors.primary_500,
                  borderRadius: '50px',
                  width: 296,
                  height: 48,
                  cursor: 'pointer',
                  background: Colors.primary_500,
                  margin: '16px 0 8px 0',
                }}
                onClick={() => setShowInviteFavoritesPopup(true)}
              >
                <img
                  src={shareIcon}
                  alt="icon"
                  style={{ height: 24, width: 24, marginRight: 8 }}
                />
                <p
                  className="global_font f-dark bold f-18"
                  style={{
                    textAlign: 'center',
                    cursor: 'pointer',
                    color: Colors.white,
                    textTransform: 'none',
                  }}
                >
                  Send to Favorites
                </p>
              </button>
            </div>
          </div>
        </div>
      </div>

      {showInviteFavoritesPopup && (
        <InviteFavorites
          setShowInviteFavoritesPopup={setShowInviteFavoritesPopup}
        />
      )}

      {cancelJobPopup && (
        <ConfirmPopup
          Icon={() => <AnimatedCloseCircle />}
          title="Are you sure you want to cancel?"
          titleStyle={{ marginTop: 20 }}
          description="Canceling an active shift means that it will no longer be available to professionals around your office to accept and potentially work."
          descriptionStyle={{ marginBottom: 50 }}
          leftButtonText="Go Back"
          leftButtonAction={() => setCancelJobPopup(false)}
          rightButtonText="Cancel Shift"
          rightButtonAction={() => {
            dispatch(cancelJob({ jobId: job.id, redirect: true }));

            setCancelJobPopup(false);
          }}
        />
      )}
    </div>
  );
};
